<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="m-3">
            <h3>Edit Notice</h3>
            <div v-if="pageLoading" class="mt-3">
                Loading...
            </div>
            <EditElement :elementIdProp="pageId" category_id="4"></EditElement>
        </div>
    </div>
</template>

<script>
import EditElement from "@/components/ElementComponents/EditElement";

export default {
    name: 'editNotice',
    components: {
        EditElement,
    },
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Notices',
                    to: '/notices/all'
                }, {
                    text: 'Edit Notice',
                    href: '#'

                }
            ],
            pageId: null,
        };
    },
    created() {
        this.pageId = this.$route.params.id;
    },
}
</script>